<template>
  <div class='cardCheckInfo'>
    <div class="return">
      <el-button type="primary"
                 @click="backFun">返回</el-button>
    </div>
    <el-divider content-position="left">
      <span style="color:#2897FF; font-weight: 650;font-size: 16px;">基础信息</span>
    </el-divider>

    <div class="content">
      <div class="contentImage">
        <img :src="$isWuHan ? require('../../assets/card-logo.png') : require('../../assets/card-logo.png')">
      </div>
      <div class="contentInfo">
        <el-row>
          <el-col :span="12">
            <div class="infoItem"
                 v-for="item in content.infoLeft"
                 :key="item.cardNo"><span>{{item.label}}</span>{{item.value}}</div>
          </el-col>
          <el-col :span="12">
            <div class="infoItem"
                 v-for="item in content.infoRight"
                 :key="item.cardNo"><span>{{item.label}}</span>{{item.value}}</div>
          </el-col>
        </el-row>
      </div>
    </div>

    <el-divider content-position="left">
      <span style="color:#2897FF; font-weight: 650;font-size: 16px;">消费记录</span>
    </el-divider>
    <Table :TableParam="dialogTable">
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Table from '@/components/Table'
import Paging from '@/components/Paging'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },
      content: {
        infoLeft: [],
        infoRight: []
      },
      dialogTable: { //  Dialog 列表
        isHeader: false,
        data: [],
        column: [
          { prop: 'orderNo', label: '订单号' },
          { prop: 'amount', label: '消费金额' },
          { prop: 'shopName', label: '消费店铺' },
          { prop: 'orderTime', label: '消费时间' }
        ]
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {

  },
  // 方法集合
  methods: {
    backFun () {
      history.back()
    },
    async getItemList () {
      const { pager, content, dialogTable } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        cardNo: content.cardNo
      }
      const { status, data = {} } = await this.$http.getConsumeList(params)
      if (status === 200) {
        pager.count = data.total
        dialogTable.data = data.list
      }
    },
    async getCardInfo () {
      const params = {
        id: this.$route.query.id
      }
      const { status, data = {} } = await this.$http.getCardInfo(params)
      if (status === 200) {
        const infoLeft = [
          {
            label: '卡名称：',
            value: data.cardName
          },
          {
            label: '卡编号：',
            value: data.cardNo
          },
          {
            label: '卡类型：',
            value: data.cardTypeName
          },
          {
            label: '面值：',
            value: data.denomination
          },
          {
            label: '有效期：',
            value: data.validPeriod
          },
          {
            label: '适用店铺：',
            value: data.shopNames
          }
        ]
        const infoRight = [
          {},
          {
            label: '会员id：',
            value: data.bindAccount
          },
          {
            label: '卡密钥：',
            value: data.cardKey
          },
          {
            label: '余额：',
            value: data.remaining
          },
          {
            label: '创建日期：',
            value: data.createTime
          }
        ]

        this.content = {
          infoLeft,
          infoRight,
          cardNo: data.cardNo
        }
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  async created () {
    await this.getCardInfo()
    await this.getItemList()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.cardCheckInfo {
  padding: 30px 20px 0;
  margin: 20px;
  background-color: #fff;
  border-radius: 10px;
  .return {
    display: flex;
    justify-content: flex-end;
    .el-button {
      width: 100px;
    }
  }
  .content {
    padding: 0 80px;
    box-sizing: border-box;
    display: flex;
    margin-top: 50px;
    .contentImage {
      width: 150px;
      height: 150px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .contentInfo {
      flex: 1;
      margin-left: 50px;
      .infoItem {
        width: 100%;
        min-height: 50px;
        font-weight: 200;
        word-break: break-all;
        & > span {
          display: inline-block;
          width: 80px;
          text-align: right;
        }
      }
    }
  }
  .container {
    padding: 0;
  }
}
</style>
